import React, {useState, useEffect} from 'react';
import "./Footer.css";

function Footer(props) {

	const [date, setDate] = useState(0);

	useEffect(() => {
		setDate(new Date().getFullYear());
	}, []);

	return (
		<>
			<div className="footer-wrap">
				<div className="footer">
					<div><span className={"firma"}>iWEB Studio</span> Bořivojova 86, Písek, Česká republika | Email: <a href="mailto:info@e23.cz">info@e23.cz</a></div>
					<div className={"copy"}>Copyright © {date} <a href="http://www.e23.cz">e23.cz</a></div>
				</div>
			</div>
		</>
	);
}

export default Footer;